<main class="auth-layout">
  <section class="auth-layout__brand">
    <span class="auth-layout__mark">  <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="40"
  height="40"
  fill="none"
  stroke="currentColor"
  stroke-width="1.2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <!-- Outer faceted polygon -->
  <polygon points="12,1.8 21.5,7 18,18 12,22 6,18 2.5,7" />

  <!-- Facet lines -->
  <line x1="12" y1="1.8" x2="8" y2="8.2" />
  <line x1="12" y1="1.8" x2="16" y2="8.2" />
  <line x1="2.5" y1="7" x2="8" y2="8.2" />
  <line x1="21.5" y1="7" x2="16" y2="8.2" />
  <line x1="6" y1="18" x2="8" y2="8.2" />
  <line x1="18" y1="18" x2="16" y2="8.2" />
  <line x1="6" y1="18" x2="12" y2="14.8" />
  <line x1="18" y1="18" x2="12" y2="14.8" />

  <!-- Center eye -->
  <path
    d="M6.2 12
       Q12 6.8 17.8 12
       Q12 17.2 6.2 12Z"
  />

  <!-- Iris -->
  <circle cx="12" cy="12" r="2.5" />

  <!-- Pupil -->
  <circle
    cx="12"
    cy="12"
    r="1"
    fill="currentColor"
    stroke="none"
  />

  <!-- Eye highlight -->
  <circle
    cx="12.7"
    cy="11.3"
    r="0.35"
    fill="currentColor"
    stroke="none"
  />
</svg></span>
    <div class="auth-layout__brand-copy">
      <h1 class="auth-layout__title">{{ appName }}</h1>
      <p class="auth-layout__subtitle">Industrial Data Integration Platform</p>
    </div>
  </section>
  <section class="auth-layout__content">
    <router-outlet />
    <p class="auth-layout__footer">{{ appName }}</p>
  </section>
</main>
